import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=147e8b18&"
import script from "./Fail.vue?vue&type=script&lang=js&"
export * from "./Fail.vue?vue&type=script&lang=js&"
import style0 from "./Fail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports